import React from 'react';
import {
  IonAlert,
  IonButton,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonLoading,
} from '@ionic/react';

import MembershipCard from '../components/MembershipCard';
import MembershipInfo from '../components/MembershipInfo';
import { Membership } from '../lib/functionality';

import styles from './Account.module.css';

interface AccountProps {
  membership?: Membership;
  userLogout: () => void;
}

const Account = ({ membership, userLogout }: AccountProps) => {
  const [showLogoutConfirm, setShowLogoutConfirm] =
    React.useState<boolean>(false);

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>My Membership</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonLoading
          showBackdrop={true}
          animated={true}
          isOpen={!membership}
          message="Getting membership..."
        />
        <IonAlert
          isOpen={showLogoutConfirm}
          onDidDismiss={() => setShowLogoutConfirm(false)}
          header={'Logout?'}
          message={'Are you sure you want to log out?'}
          buttons={[
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => {},
            },
            {
              text: 'Logout',
              handler: () => {
                userLogout();
              },
            },
          ]}
        />
        <div className={styles.container}>
          <MembershipCard membership={membership} />
          <MembershipInfo membership={membership} />
          <IonButton expand="block" onClick={() => setShowLogoutConfirm(true)}>
            Log out
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Account;
